<div class="bcg p-4">
  <div class="row">
    <div class="col-lg-8 col-sm-6 col-md-6">
      <!-- <p class="nav_link_cat ms-1">
        <span class="clickable" (click)="back()">Dashboard</span>
        <span style="color: rgba(33, 37, 41, 0.75);" [style.font-weight]="'bold'"> >> </span>
        <span style="color: rgba(33, 37, 41, 0.75);">E-Sign</span>
      </p> -->
      <div class="d-flex justify-content-between custom-container">
        <nav class="custom-nav">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" style="cursor: pointer;"  (click)="back()">Dashboard</li>
            <li class="breadcrumb-item active" style="cursor: context-menu;" aria-current="page">E-Sign</li>
          </ol>
        </nav>
      </div>
    </div>
    <div *ngIf="showUploadFileDetails" class="col-lg-4 col-sm-6 col-md-6 overlay">
      <app-select-branch (OnBranchChangeData)=changeState($event)></app-select-branch>
    </div>
  </div>

  <div *ngIf="showUploadFileDetails" class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">E-Sign</h5>
          <p class="card-text text_p ">E-Sign the Uploaded documents on the Cloud</p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">

          <p-button label="Back" (click)="back()" styleClass="p-button-sm"></p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card my-3 card_style_bs_order_cat card_outLine">
    <div class="card-body " style="padding-bottom: 0;">
      <span class="title_five">Finish Setting Up in Three Simple Steps</span>
      <ul class="steps_style " style="padding-left: 0;">
        <li [ngClass]="[active_Upload ? 'box-item_active' : '', showUploadFileDetails ? 'boxOutline' : 'box-item']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable"
          (click)="showUploadFileDetails ? gotToCatEditScreen('upload') : null">1. Upload Document
        </li>
        <li [ngClass]="[active_eSign ? 'box-item_active' : '', showEsignDetails ? 'boxOutline' : 'box-item']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable">2. Signing details
          <span *ngIf="!esignData.toBeEsigned">(skipped)</span>
        </li>
        <li [ngClass]="[active_confirm ? 'box-item_active' : '', showConfirmation ? 'boxOutline' : 'box-item']"
          class="col-lg-2 col-md-2 col-sm-3 col-4  clickable">3. Order
          confirmation</li>
      </ul>
    </div>
  </div>

  <div *ngIf="showEsignDetails" class="text-right m-2">
    <p class="text_p">Try <a [routerLink]="['/doqfy/bulk-upload/form', 'e-sign']" trackClick="click_bulk_upload_esign" class="btn-link clickable link_text">
        Bulk Upload </a>if you have more than 5 E-Sign details.
  </div>
  <div *ngIf="showUploadFileDetails" class="mt-2">
    <app-e-sign-upload [uploadFileData]="uploadFileData"
      (uploadFileChange)="onUploadFileDataChange($event)"></app-e-sign-upload>
  </div>
  <div *ngIf="showEsignDetails">
    <app-e-sign-details [esignData]="esignData" (esignDataChange)="onesignDataChange($event)" [uploadFileData]="uploadFileData"
    (uploadFileChange)="onUploadFileDataChange($event)" [service]="'E-Sign'"></app-e-sign-details>
  </div>
  <div *ngIf="showConfirmation">
    <app-order-confirmation-details #orderDetails [orderConfirmationData]="orderConfirmationData"
      (orderConfirmationChange)="onOrderConfirmationChange($event)"></app-order-confirmation-details>
  </div>


</div>


<p-confirmDialog [style]="{width: '50vw'}" (onAccept)="onApproveMethod($event)"></p-confirmDialog>


<ng-template #reviewOrder let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <app-review-order-details [reviewOrderData]="reviewOrderData"
        (reviewOrderDataChange)="reviewOrderDataChange($event)"></app-review-order-details>
    </div>
  </div>
</ng-template>

<ng-template #paymentScreen let-modal>
  <div class="modal-header">
    <!-- <h5 class="modal-title">Payment Details</h5> -->
    <strong>{{ paymentDetails.paymentMethod === 'wallet' ? 'Payment Details (Wallet)' : 'Payment Details' }}</strong>
    <button type="button" class="btn-close" (click)="closeModel()" aria-label="Close"></button>
  </div>
  <div class="modal-body" style="padding: 1.5rem; overflow-y: auto; max-height: 80vh;">
    <app-payment-order [paymentOrderData]="paymentOrderData"
      (paymentOrderDataChange)="paymentOrderDataChange($event)"></app-payment-order>
  </div>
</ng-template>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>